"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=movement-type.dto.js.map